// src/pages/Home.js
import React from 'react';
import './home.css';
import { useNavigate } from 'react-router-dom';
import CardSlider from '../components/cardSlider';
import BrandSlider from '../components/brandSlider';
import peopleSmile from'../assets/images/headimg.jpg'
import Electricity from '../assets/images/electric-icon.jpg';
import Gas from '../assets/images/gas-icon.png';
import Water from '../assets/images/water-icon.png';
import image1 from '../assets/images/image-11.jpg';
import image2 from '../assets/images/image-2.jpg';
import energy from '../assets/images/sme.jpg';
import Explain from '../assets/images/energy-explain.jpg';

function Home() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/Contacts');
  };
  return (
    <div className="home-page">
      {/* <section className="hero-banner">
        <div className="hero-content">
          <div className="hero-item">
            <i className="fas fa-file-signature"></i>
            <span>Quotes available for pilot customers</span>
          </div>
          <div className="hero-item">
            <i className="fas fa-balance-scale"></i>
            <span>Compare suppliers in early tests</span>
          </div>
          <div className="hero-item">
            <i className="fas fa-tag"></i>
            <span>Pricing under review</span>
          </div>
          <div className="hero-item">
            <i className="fas fa-star"></i>
            <span>Customer feedback coming soon</span>
          </div>
        </div>
      </section> */}
      <section className="hero-banner-contect">
        <div className="hero-content-wrapper">
          <div className="hero-text">
            <p className="section-label">SUSTAINABLE ENERGY SOLUTIONS</p>
            <h1>
              Smart, reliable utility management for electricity, gas, and water<br />
              <span className="highlight">Orbit Energy</span> — empowering businesses to operate greener and smarter
            </h1>


            <button className="hero-btn" onClick={handleClick}>Save more now</button>
            <div className="stats">
              <div><strong>Early-stage</strong><br />Pilot Customers</div>
              <div><strong>Trusted & Reliable</strong><br />Utility Partner</div>
              <div><strong>Building Value</strong><br />Step by Step</div>
            </div>
          </div>
          <div className="hero-image">
            <div className="blob">
              <img src={peopleSmile} alt="Business owners" />
            </div>
          </div>
        </div>
      </section>

     <section className="hero">
      {/* <div className="trustpilot-link">
        <a 
          href="https://www.trustpilot.com/review/orbitenergy.solutions" 
          target="_blank" 
          rel="noreferrer"
        >
          Review us on <span className="star">★</span> Trustpilot
        </a>
      </div> */}
      <h1 style={{ width: '80%', margin: 'auto', textAlign: 'center' }}>
        We provide a complete business energy comparison service, helping you evaluate the most competitive gas and electricity rates. <br />
         By partnering with leading utility suppliers, we deliver the best real-time quotes tailored to your business needs.
      </h1>
      <p style={{ textAlign: 'center', marginTop: '20px' }}>
        We are in the early stages, offering tools and guidance for pilot customers. Stay updated as we grow.
      </p>
      <button className="hero-btn" onClick={handleClick}>
        Request Info
      </button>
    </section>

      <section className="cards">
        <div className="card">
          <div className="icon"><img src={Gas} alt="Gas" /></div>
          <div className="info">
            <h3>Gas</h3>
            <p>
              We connect businesses with trusted gas suppliers and help set up meters efficiently.  
              Our team guides you through the process, helping you access competitive prices and manage costs reliably.
            </p>
            <button 
              className="quote-btn orange" 
              onClick={handleClick}
            >
              Send a Query
            </button>
          </div>
        </div>
        <div className="card">
          <div className="icon"><img src={Electricity} alt="Electricity" /></div>
          <div className="info">
            <h3>Electricity</h3>
            <p>
              Providing reliable access to electricity suppliers and meter setup for businesses.  
              We guide you through the process, helping you secure competitive prices and manage costs effectively.
            </p>
            <button 
              className="quote-btn pink" 
              onClick={handleClick}
            >
              Send a Query
            </button>
          </div>
        </div>
        <div className="card">
          <div className="icon"><img src={Water} alt="Water" /></div>
          <div className="info">
            <h3>Water</h3>
            <p>Better water deals with improved service and reduced costs. Let us help.</p>
            <button 
              className="quote-btn blue" 
              onClick={handleClick}
            >
              Ask a Question
            </button>
          </div>
        </div>
      </section>
      <section className="alt-sections">
      <div className="alt-section">
        <div className="alt-image">
          <img src={image1} alt="section 1" />
        </div>
        <div className="alt-text">
          <h2>Long-term goals for our clients</h2>
        <p>
          Our strength lies in forging long-term, trusted partnerships with our clients, 
          allowing us to gain deep insights into their unique business needs. 
          This understanding enables us to deliver highly tailored and strategic utility solutions that drive real value 
          and long-term savings.
        </p>
        </div>
      </div>

      <div className="alt-section reverse">
        <div className="alt-image">
          <img src={image2} alt="section 2" />
        </div>
        <div className="alt-text">
          <h2>Trusted advice from experts</h2>
            <p>
              Our advice is always honest and tailored to your unique requirements. 
              Our experienced consultants take the time to understand your business, 
              providing clear and practical guidance to help you choose the most effective commercial utility solutions.
            </p>
        </div>
      </div>
    </section>
    <section className="card-slider-section">
    <CardSlider />
    </section>
    <section style={{backgroundColor: '#f3fcff'}}>
      <div className="alt-section" style={{width: '80%', margin: 'auto', marginBottom: '4rem'}}>
         <div className="alt-text">
          <h1>Save up to 65% on commercial utilities</h1>
        <p>
          Every penny you can save on business energy and business utilities will help your business and increase your profits.
        </p>
        </div>
        <div className="alt-text">
        <p>
          Orbit-Energy works closely with the UK’s leading energy suppliers to deliver more affordable quotes than you’d find anywhere else. Cutting your business energy bills down can make a huge difference to your bottom line, and we’ll do all the legwork allowing you to focus on the hectic nature of being a business owner.
        </p>
        </div>
      </div>

      <div className="alt-section reverse" style={{width: '80%', margin: 'auto', paddingBottom: '4rem', marginBottom: '0'}}>
        <div className="alt-image">
          <img src={energy} alt="section 2" />
        </div>
        <div className="alt-text">
          <h2>We'll find the perfect solution, tailored to your business</h2>
            <p>
              At Orbit Energy Solutions, we understand that every business is unique. That’s why we deliver tailored energy solutions designed around your specific requirements. Our expert consultants bring extensive experience across diverse industries — from SMEs to large enterprises and public organizations. Leveraging our deep knowledge of the energy market, we provide optimized electricity, gas, and water plans that align perfectly with your operational needs and cost objectives.
            </p>
        </div>
      </div>
    </section>
    {/* <section className="brand-slider-section">
      <BrandSlider />
    </section> */}
     <section className='explain-section'>
      <div className="alt-section"  style={{width: '80%', margin: 'auto', paddingBottom: '2rem', paddingTop: '2rem'  }}>
        <div className="alt-text">
          <h2 style={{fontSize: '3rem'}}>Looking to switch to greener energy?</h2>
        <p>
        Across the globe, more businesses are taking meaningful steps to reduce their carbon footprint and operate more sustainably. One of the most effective ways to achieve this is by transitioning to renewable energy sources — a move that not only strengthens your corporate image but also advances your environmental and social responsibility goals.
        </p>
        <p>
        At Orbit Energy Solutions, we provide expert guidance on the most suitable renewable energy options for your organization. Whether you’re an SME, a large enterprise, or part of the public sector, our consultants help you navigate the growing landscape of green energy providers. As the renewable market expands, tariffs are becoming increasingly competitive — and with Orbit Energy Solutions, you can secure the perfect balance between sustainability and cost efficiency.
        </p>
        </div>
        <div className="Exp-image">
          <img src={Explain} alt="section 1" />
        </div>
      </div>
    </section>
    </div>
  );
}

export default Home;
